import script from "./Photos.vue?vue&type=script&setup=true&lang=js"
export * from "./Photos.vue?vue&type=script&setup=true&lang=js"

import "./Photos.vue?vue&type=style&index=0&id=9fb9cb40&lang=scss"

const __exports__ = script;

export default __exports__